export interface TopUpAccountStatus {
    maximumTopUpAmount: number;
    minimumTopUpAmount: number;
}
